import { UTM_BUILDER_DEFAULTS } from '../../config/utmBuilderDefaults'
import { resolveOwnerLabel } from '../../utils/utm/resolveOwnerLabel'

export const resolveCampaignLinkResponsibleLabel = (row = {}) => {
  if (!row.responsible) {
    return '—'
  }

  const resolvedLabel = resolveOwnerLabel(row.responsible, UTM_BUILDER_DEFAULTS.owners)

  if (resolvedLabel !== 'Не знайдено') {
    return resolvedLabel
  }

  return row.responsibleLabel || resolvedLabel
}

export default resolveCampaignLinkResponsibleLabel
